// extracted by mini-css-extract-plugin
module.exports = {"reasons":"styles-module--reasons--1OY0D","reasons__cards":"styles-module--reasons__cards--3pNTQ","reasons__reasons":"styles-module--reasons__reasons--hxav8"};